import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/nextjs';
import { GetMarketplacePropertySellerDisclosuresDocument } from '__generated__/athena/graphql';
import { getAthenaClient } from 'components/api';
import { ClientError } from 'graphql-request';

export const useSellerDisclosures = (addressToken?: string) => {
  const [sellerDisclosures, setSellerDisclosures] = useState<string | null | undefined>();

  useEffect(() => {
    if (!addressToken) {
      return;
    }
    const controller = new AbortController();
    const fetchSellerDisclosures = async () => {
      try {
        const data = await getAthenaClient(undefined, { signal: controller.signal }).request(
          GetMarketplacePropertySellerDisclosuresDocument,
          { addressToken },
        );
        setSellerDisclosures(data?.marketplace?.property?.sellerDisclosuresDownloadUrl);
      } catch (error) {
        // The disclosures link only augments the SSR-rendered page. Report only
        // server-reported failures (ClientError); a bare network-layer
        // TypeError is an expected abort (navigation or tab teardown).
        if (error instanceof ClientError) {
          Sentry.captureException(error);
        }
      }
    };
    void fetchSellerDisclosures();
    return () => {
      controller.abort();
    };
  }, [addressToken]);

  return { sellerDisclosures };
};
